/**
 * Component: Facebook page plugin
 * Handle the facebook page plugin, and the spinner show/hide
 */


var dnDepartments = dnDepartments || {};
dnDepartments.socialMedia = dnDepartments.socialMedia || {};

dnDepartments.socialMedia.facebook = dnDepartments.socialMedia.facebook || function () {

    this.init = function() {
        window.fbAsyncInit = function() {
            FB.init({
                xfbml      : true,
                version    : 'v2.5'
            });

            // Load Novicell local scripts here, after FB has initiated.
            pageplugin();
        };

        (function(d, s, id){
            var js, fjs = d.getElementsByTagName(s)[0];
            if (d.getElementById(id)) {return;}
            js = d.createElement(s); js.id = id;
            js.src = "//connect.facebook.net/en_US/sdk.js";
            fjs.parentNode.insertBefore(js, fjs);
        }(document, 'script', 'facebook-jssdk'));
    };

    this.pageplugin = function() {
        if ($('#js-facebook-page-plugin').length > 0) {
            FB.Event.subscribe('xfbml.render', function(response) {
                $('#js-facebook-page-plugin .spinner').fadeOut('slow', function(){
                    $('#js-facebook-page-plugin .fb-page').fadeIn();
                    
                    $('.fb-page').find('span').prepend($.parseHTML('<div class="newsletter-signup-content__title">F&oslash;lg os p&aring; Facebook</div>'));
                });
            });
        }
    };

    return {
        init:init
    };
}();
